import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { HeartIcon } from 'lucide-react';
const transformations = ['No vas a ser millonario, pero vas a recuperar el silencio cómplice.', 'Vas a poder entrar a tu casa sin sentir que entras a un campo de batalla.', 'Vas a volver a ver a tu pareja como tu aliado frente al caos, no como otro problema a resolver.'];
export function TransformationSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-20 md:py-28 bg-[#F0EDEB]" data-id="element-167">
      <div className="max-w-3xl mx-auto px-6" data-id="element-168">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} data-id="element-169">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2D2D2D] mb-12 text-center" data-id="element-170">
            Lo que cambia en una semana:
          </h2>

          <div className="relative" data-id="element-171">
            <div className="absolute -inset-1 bg-gradient-to-r from-[#722F37]/30 via-[#722F37]/30 to-[#722F37]/30 rounded-2xl blur opacity-50" data-id="element-172"></div>

            <div className="relative bg-[#FFFFFF] rounded-2xl p-8 md:p-10 border border-black/10" data-id="element-173">
              <div className="flex flex-col md:flex-row gap-4 mb-8 pb-8 border-b border-black/10" data-id="element-174">
                <div className="flex-1 bg-[#8B1A2B]/10 border border-[#8B1A2B]/20 rounded-lg p-4 text-center" data-id="element-175">
                  <span className="text-[#8B1A2B] font-bold text-sm tracking-widest uppercase mb-1 block" data-id="element-176">
                    Antes
                  </span>
                  <p className="text-[#6B7280] text-sm" data-id="element-177">
                    Estrés, peleas constantes, distancia emocional y
                    agotamiento.
                  </p>
                </div>
                <div className="flex-1 bg-[#722F37]/10 border border-[#722F37]/20 rounded-lg p-4 text-center" data-id="element-178">
                  <span className="text-[#722F37] font-bold text-sm tracking-widest uppercase mb-1 block" data-id="element-179">
                    Después
                  </span>
                  <p className="text-[#2D2D2D] text-sm" data-id="element-180">
                    Paz mental, equipo unido, comunicación clara y alivio.
                  </p>
                </div>
              </div>

              <div className="space-y-6" data-id="element-181">
                {transformations.map((item, index) => <motion.div key={index} initial={{
                opacity: 0,
                x: -20
              }} animate={isInView ? {
                opacity: 1,
                x: 0
              } : {
                opacity: 0,
                x: -20
              }} transition={{
                duration: 0.5,
                delay: index * 0.1
              }} className="flex gap-4 items-start" data-id="element-182">
                    <HeartIcon className="w-6 h-6 text-[#722F37] flex-shrink-0 mt-1 fill-[#722F37]" data-id="element-183" />
                    <p className="text-lg md:text-xl text-[#2D2D2D] font-medium leading-relaxed" data-id="element-184">
                      {item}
                    </p>
                  </motion.div>)}
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}